
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.833 2.5H12.35A2.509 2.509 0 0010 .833c-1.083 0-2 .7-2.35 1.667H4.167C3.25 2.5 2.5 3.25 2.5 4.167v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.666V4.167c0-.917-.75-1.667-1.667-1.667zM10 2.5c.458 0 .833.375.833.833a.836.836 0 01-.833.834.836.836 0 01-.833-.833c0-.459.375-.834.833-.834zm1.667 11.667H5.833V12.5h5.834v1.667zm2.5-3.333H5.833V9.167h8.334v1.667zm0-3.334H5.833V5.833h8.334V7.5z"}})])
          )
        }
      }
    